/* global location */
import { useState, useEffect } from 'preact/hooks';

export function rootPath(rel, base = '') {
  const d = 'http://a.b/';
  const url = new URL(rel, d + base);
  const retval = url.href.replace(d, '');
  return retval;
};

const hashChange = (setState, defHash, locHash) => {
  if (typeof locHash !== 'string') locHash = location.hash;
  if (!locHash) locHash = defHash;
  locHash = locHash.replace(/^#/, '');
  const rawHash = locHash;
  locHash = rootPath(locHash);
  console.log('lochash', locHash);
  const [fullPath, hash] = locHash.split('#');
  const [path, prms] = fullPath.split('?');
  const params = prms?.split('&')?.reduce((a, c) => {
    const [key, value] = c.split('=');
    a[key] = (a[key] || '') + (value || '');
    return a;
  }, {});
  const s = {
    rawHash,
    fullPath,
    hash,
    path,
    params,
    // history: TODO
    // newURL: e?.newURL,
    // oldURL: e?.oldURL,
  };
  // match(pat, s);
  setState(s);
};

export function useHash(defHash) {
  const [state, setState] = useState({});

  useEffect(() => {
    const myHashChange = hashChange.bind(null, setState, defHash);
    myHashChange();
    window.addEventListener('hashchange', myHashChange);
    window.addEventListener('popstate', myHashChange);
    return () => {
      window.removeEventListener('hashchange', myHashChange);
      window.removeEventListener('popstate', myHashChange);
    };
  }, []);
  return state;
}

/* eslint-disable no-return-assign */
/*
function match(pat, s, key, matches) {
  if (!key && typeof pat === 'string') pat = new RegExp(pat);
  if (pat instanceof RegExp) return s.match = pat.exec(s.path);
  else if (typeof pat === 'object') {
    // if (!key && typeof pat?.path === 'string') pat.path = new RegExp(pat.path);
    s.matches = {};
    s.match = true;
    Object.keys(pat).forEach(k => {
      // s.matches[k] =
    });
  }
}
*/
